import { Random } from '../core/Random';
import type { JobKind } from '../state/types';
import { HAUL_SITES, MOW_SITES } from '../world/layout';

export interface JobOffer {
  id: string;
  kind: JobKind;
  title: string;
  desc: string;
  pay: number;
  site: string;
  cargo?: string;
  /** Game minutes allowed to finish once accepted. */
  minutes: number;
}

const CARGO = [
  'busted fridge',
  'water-stained mattress',
  'haunted recliner',
  'dead washing machine',
  'mystery couch',
  'broken treadmill (clothes rack)',
] as const;

export function possessive(name: string): string {
  return name.endsWith('s') ? `${name}'` : `${name}'s`;
}

/** Job board offers are deterministic per save seed + day, so reloading can't reroll them. */
export function jobsForDay(seed: number, day: number): JobOffer[] {
  const rng = new Random((seed ^ Math.imul(day, 2654435761)) >>> 0);
  const mowSite = rng.pick(Object.keys(MOW_SITES));
  const mow = MOW_SITES[mowSite];
  const haulSite = rng.pick(Object.keys(HAUL_SITES));
  const haul = HAUL_SITES[haulSite];
  const cargo = rng.pick(CARGO);
  return [
    {
      id: `d${day}-mow`,
      kind: 'mow',
      title: `Mow ${possessive(mow?.owner ?? 'somebody')} lawn`,
      desc: 'Push mower provided. Gas is "mostly" in it. Pay scales with how much you actually mow.',
      pay: rng.int(45, 65),
      site: mowSite,
      minutes: 300,
    },
    {
      id: `d${day}-haul`,
      kind: 'haul',
      title: `Haul ${possessive(haul?.owner ?? 'somebody')} ${cargo} to the junkyard`,
      desc: "Pick it up, carry it to Junkyard Jerry's drop-off. Lift with your legs. Or don't, you're not a doctor.",
      pay: rng.int(30, 50),
      site: haulSite,
      cargo,
      minutes: 360,
    },
  ];
}
